// Copyright 2019 Sorama B.V.

import { containerless, customElement } from "aurelia-framework";
import { AspectFixed } from "./AspectFixed";
import { AspectItemElement, AspectItemsCatalog } from "./AspectItemsCatalog";
import { AspectItemRatio, IAspectItem } from "./IAspectItem";

@customElement("aspect-group")
@containerless
export class AspectGroup implements IAspectItem {
    private contentElement: HTMLDivElement;

    constructor(private readonly aspectItemsCatalog: AspectItemsCatalog) {}

    public attached(): void {
        this.aspectItemsCatalog.subscribe({
            viewModel: this,
            element: this.contentElement,
        });
    }

    public getArea(maxWidth: number, maxHeight: number): AspectItemRatio {
        if (!this.contentElement) return;

        const result: AspectItemElement[] = [];
        const element = this.contentElement;

        let returnValue: AspectItemRatio;
        for (let i = 0; i < element.children.length; i++) {
            const child: Element = element.children[i];

            const item = this.aspectItemsCatalog.getItem(child);
            if (item) {
                result.push(item);
            }
        }

        // Optimise
        const fixedElements = result.filter((x) => x.viewModel instanceof AspectFixed);
        const fixedElementsHeight = fixedElements
            .map((x) => {
                return x.viewModel.getArea(maxWidth, maxHeight).height;
            })
            .reduce((x, y) => {
                return x + y;
            });

        const finalResult = <AspectItemRatio>{
            height: fixedElementsHeight,
            width: 0,
            ratio: 0,
        };

        const restElements = result.filter((x) => !(x.viewModel instanceof AspectFixed));
        for (const el of restElements) {
            const elementArea = el.viewModel.getArea(
                maxWidth,
                Math.max(maxHeight - fixedElementsHeight, 0) / restElements.length
            );

            finalResult.width = Math.max(elementArea.width, finalResult.width);
            finalResult.height += elementArea.height;
        }

        finalResult.ratio = finalResult.width / finalResult.height;
        return finalResult;
    }
}
